import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { BaseApiService } from '@prv/apis';
import * as i1 from '@angular/common/http';
import * as i2 from '@nexa/configuration';

/**
 * Payload resultante del agendamiento
 */
class ResultAvailabilityDto {
}

/**
 * Servicio encargado de retornar la disponibilidad de citas dsiponibles
 */
class EngineAvailabilityApiService extends BaseApiService {
    /**
     * Crea una nueva instancia de @see EngineAvailabilityApiService
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'engine-availability', 'EngineAvailability');
    }
    /***
      * Metodo encargado de consultar las disponibilidades de agenda
      * @param args Argumentos para la consulta de información
      * @returns Returns un array con la información de los nodos @see ResultAvailabilityDto
      */
    getAvailability(args) {
        return this.getUri(uri => this.httpClient.post(`${uri}/GetAvailability`, args));
    }
    /***
      * Metodo encargado de consultar las disponibilidades de agenda desde medios externos
      * @param data Objeto encriptado y serializado con la información a consultar
      * @returns Returns una cadena encriptada y serializada con la información de disponibilidades @see DataExternalDto
      */
    getAvailabilityExternal(data) {
        return this.getUri(uri => this.httpClient.post(`${uri}/GetAvailabilityExternal`, data));
    }
}
EngineAvailabilityApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: EngineAvailabilityApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
EngineAvailabilityApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: EngineAvailabilityApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: EngineAvailabilityApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/*
 * Public API Surface of engine-availability
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EngineAvailabilityApiService, ResultAvailabilityDto };
